import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Panel, Label} from 'react-bootstrap';
import {FlircConfigFile} from "./utils";
import {map as _map} from 'lodash';

class FlircConfigSettings extends Component {
    render() {
        return (
            <Panel header={<h1>Settings</h1>}>
                <dl className="dl-horizontal">
                    <dt>ROM tables</dt>
                    <dd>
                        {
                            _map(this.props.flircConfig.settings.romtables, ([tname, enabled], idx) => {
                                return (<span key={idx.toString()}><Label bsStyle={enabled ? 'success' : 'danger'}>{tname}</Label> </span>);
                            })
                        }
                    </dd>
                    <dt>Timing</dt>
                    <dd>{this.props.flircConfig.settings.timing}</dd>
                </dl>
            </Panel>
        )
    }
}

FlircConfigSettings.propTypes = {
    flircConfig: PropTypes.instanceOf(FlircConfigFile).isRequired,
};

export default FlircConfigSettings;



// WEBPACK FOOTER //
// ./src/FlircConfigSettings.js